import { Fragment } from 'react'
import PropTypes from 'prop-types'

import { HeaderContainer } from 'lmcv/containers/Header'
import { ModalContainer } from 'lmcv/containers/Modal'

function AuthLayout ({ children }) {
  return (
    <Fragment>
      <HeaderContainer />
      <ModalContainer />
      {children}
    </Fragment>
  )
}

AuthLayout.propTypes = {
  children: PropTypes.node.isRequired
}

export default AuthLayout
